import { client } from "@/apis/client";
import { useQuery } from "@tanstack/react-query";

// TODO: API Docs 적용이 안되어있음
const useUserQuery = () => {
  return useQuery({
    queryKey: ["user"],
    queryFn: async () => client.GET(`/api/myInfo`),
    select: (data) => data?.data?.data,
  });
};

export default useUserQuery;
